import { render, staticRenderFns } from "./EditCourse.vue?vue&type=template&id=ed8ef3e6&scoped=true&"
import script from "./EditCourse.vue?vue&type=script&lang=js&"
export * from "./EditCourse.vue?vue&type=script&lang=js&"
import style0 from "./EditCourse.vue?vue&type=style&index=0&id=ed8ef3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8ef3e6",
  null
  
)

export default component.exports